var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import { ComponentFactory, ComponentFactoryResolver, EventEmitter, Injectable, Output, Type } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { OverlaySideFormService } from '../components/shared/overlay-side-form/overlay-side-form.service';
var ComponentService = /** @class */ (function () {
    function ComponentService(_componentFactoryResolver, overlaySideService, activateRoute) {
        this._componentFactoryResolver = _componentFactoryResolver;
        this.overlaySideService = overlaySideService;
        this.activateRoute = activateRoute;
        this.dataFromComponent = new EventEmitter();
        //private _overlayClose = new BehaviorSubject<any>('');
        //overlayClose = this._overlayClose.asObservable();
        this.message = new BehaviorSubject('');
        this._tabIndex = new BehaviorSubject(0);
        this._tabs = new BehaviorSubject('');
        this._currentTabs = new BehaviorSubject('');
        this._componentRouter = new BehaviorSubject([]);
        this._numberOfNav = new BehaviorSubject('');
        this.numberOfNav = this._numberOfNav.asObservable();
        this._helpNDoc = new BehaviorSubject([]);
        this._popupsSet = new BehaviorSubject([]);
        this.popupsSet = this._popupsSet.asObservable();
        this.currentPopupsSet = [];
        this._outputComponent = new BehaviorSubject([]);
        this.outputComponent = this._outputComponent.asObservable();
        //setOutputComponent
        this.eventoToolbarSubject = new Subject();
        this.eventoToolbarObs$ = this.eventoToolbarSubject.asObservable();
        this.tabs = this._tabs.asObservable();
        //tabSeted = this._tabSeted.asObservable();
        this.castMessage = this.message.asObservable();
        this.tabIndex = this._tabIndex.asObservable();
        this.tabsSeted = [];
        this.currentTabs = this._currentTabs.asObservable();
        this.navComponent = [];
        this.componentRouter = this._componentRouter.asObservable();
        this.helpNDoc = this._helpNDoc.asObservable();
        this._closeOverlayForm = new Subject();
    }
    ComponentService.prototype.eventoToolbarEmit = function (event) {
        this.eventoToolbarSubject.next(event);
    };
    ComponentService.prototype.closeOverlayForm = function () {
        return this._closeOverlayForm.asObservable();
    };
    ComponentService.prototype.emitMessage = function (message) {
        this.message.next(message);
    };
    ComponentService.prototype.ngOnDestroy = function () {
        this.message.unsubscribe();
    };
    ComponentService.prototype.destroyMessage = function () {
        this.message.next([]);
    };
    ComponentService.prototype.setTabs = function (name, tabsJson) {
        this.activateRoute.queryParams.subscribe(function (params) {
            tabsJson.forEach(function (tab) {
                tab.paramsUrl = params;
            });
        });
        this.destroyTabs(name);
        var cc = [{
                tabIndex: tabsJson.length - 1,
                name: name,
                dati: tabsJson,
                action: 'set'
            }];
        this._currentTabs.next(cc);
        this.tabsSeted.push({
            tabIndex: tabsJson.length - 1,
            name: name,
            dati: tabsJson,
            action: 'set'
        });
        this._tabs.next(this.tabsSeted);
    };
    ComponentService.prototype.addNewTab = function (name, newItem) {
        var _this = this;
        var action = 'add';
        var tabsSel;
        tabsSel = this.setActiveTabsByName(name); //SEleziono la tab dove aggiungere l'elemento
        var tabIndex = tabsSel.filter(function (tab_name) { return tab_name.tabIndex; });
        /*  //console.log(tabIndex)
         
      
      
          return */
        var currentTabs = tabsSel;
        newItem.map(function (tabToAdd) {
            currentTabs.filter(function (tab_name) { return tab_name.name == name; });
            ////console.log('currentTabs',currentTabs)
            var ele = _this.findTab(tabsSel, tabToAdd);
            if (ele > 0) {
                currentTabs.map(function (mapped) {
                    action = 'update';
                    mapped.dati.splice(ele, 1);
                });
            }
            currentTabs.map(function (mapped) {
                mapped.dati.push(tabToAdd);
                mapped.action = action;
            });
            ////console.log(currentTabs);
            ////console.log(tabsSel);
            _this._currentTabs.next(currentTabs);
            _this._tabs.next(tabsSel);
        });
        //
        //this._tabInfo.next(newItem);
        //this.selectedTab(currentTabs.dati,newItem[0]);
        // 
        // 
    };
    ComponentService.prototype.apriLinkEsterno = function (link) {
        if (!link.includes('https://') && !link.includes('http://')) {
            return window.open("https://" + link, '_blank');
        }
        else {
            window.open(link, '_blank');
        }
    };
    ComponentService.prototype.findTab = function (tabsel, tCntr) {
        var checkIndex = 0;
        tabsel.forEach(function (tab) {
            checkIndex = tab.dati.findIndex(function (val) { return val.id == tCntr.id; });
        });
        return checkIndex;
    };
    ComponentService.prototype.setActiveTabsByName = function (nameTabs) {
        var setActiveTabs = this.tabsSeted.filter(function (tabPanel) { return tabPanel.name == nameTabs; });
        //this._currentTabs.next(setActiveTabs)
        return setActiveTabs;
    };
    ComponentService.prototype.setCurrentTabPanel = function (nameTabs) {
        var setActiveTabs = this.tabsSeted.filter(function (tabPanel) { return tabPanel.name == nameTabs; });
        this._currentTabs.next(setActiveTabs);
    };
    ComponentService.prototype.selectedTab = function (tabs, itm) {
        var index = tabs.findIndex(function (value) { return value.id == itm.id; });
        this._tabIndex.next(index);
    };
    ComponentService.prototype.selectTab = function (tabs, itm) {
        tabs.forEach(function (tab) {
        });
        var index = tabs.findIndex(function (value) { return value.id == itm.id; });
        this._tabIndex.next(index);
    };
    ComponentService.prototype.destroyTabs = function (name) {
        var _this = this;
        if (name === void 0) { name = ''; }
        this.tabsSeted.map(function (setT, key) {
            if (setT.name == name) {
                _this.tabsSeted.splice(key, 1);
            }
        });
        this._tabs.next(this.tabsSeted);
        //this._tabs.pipe
    };
    ComponentService.prototype.setNavComponent = function (nav) {
        this.navComponent = nav;
        this._componentRouter.next(this.navComponent);
    };
    ComponentService.prototype.setOpzionalParameter = function (key, value, currentTabId) {
        var _a;
        var arrNavObj = [];
        var arrNav = sessionStorage.getItem('currentTabsData');
        if (arrNav)
            arrNavObj = JSON.parse(arrNav);
        var index = -1;
        if (arrNavObj) {
            index = arrNavObj.findIndex(function (res) {
                return res.currentTabId == currentTabId;
            });
        }
        if (index > -1) {
            arrNavObj[index][key] = value;
            sessionStorage.setItem('currentTabsData', JSON.stringify(arrNavObj));
        }
        else {
            var x = (_a = {
                    currentTabId: currentTabId
                },
                _a[key] = value,
                _a);
            arrNavObj.push(x);
            sessionStorage.setItem('currentTabsData', JSON.stringify(arrNavObj));
        }
    };
    ComponentService.prototype.removeOptionalParameter = function (currentTabId) {
        var arrNavObj = [];
        var arrNav = sessionStorage.getItem('currentTabsData');
        arrNavObj = JSON.parse(arrNav);
        var index = -1;
        if (arrNavObj) {
            index = arrNavObj.findIndex(function (res) {
                return res.currentTabId == currentTabId;
            });
        }
        if (index > -1) {
            arrNavObj.splice(index, 1);
            sessionStorage.setItem('currentTabsData', JSON.stringify(arrNavObj));
        }
    };
    ComponentService.prototype.getOpzionalParameter = function (key, currentTabId) {
        var arrNavObj = [];
        var arrNav = sessionStorage.getItem('currentTabsData');
        arrNavObj = JSON.parse(arrNav);
        var index = -1;
        if (arrNavObj) {
            index = arrNavObj.findIndex(function (res) {
                return res.currentTabId == currentTabId;
            });
        }
        if (index > -1) {
            if (arrNavObj[index][key])
                return arrNavObj[index][key];
        }
        else
            return null;
    };
    ComponentService.prototype.setComponentNavigation = function (cNav) {
        if (typeof cNav.idTab != 'undefined') {
            var currentNav = this.getCurrentRouterNav(cNav.idTab);
            ////console.log(currentNav);
            if (currentNav.length == 0) {
                this.navComponent.push({
                    idTab: cNav.idTab,
                    data: [{
                            id: cNav.idData,
                            title: cNav.title,
                            cRouter: cNav.cRouter,
                            params: cNav.params,
                            currentComponent: cNav.currentComponent,
                            activeCurrent: cNav.active,
                            idGroup: cNav.idGroup,
                            items: []
                        }]
                });
            }
            else {
                var index = currentNav[0].data.findIndex(function (res) {
                    return res.id == cNav.idData;
                });
                if (index < 0 && typeof cNav.title != 'undefined') {
                    currentNav[0].data.push({
                        id: cNav.idData,
                        title: cNav.title,
                        cRouter: cNav.cRouter,
                        params: cNav.params,
                        currentComponent: cNav.currentComponent,
                        activeCurrent: cNav.active,
                        idGroup: cNav.idGroup,
                        items: []
                    });
                }
                else {
                    if (currentNav[0].data[index]) {
                        currentNav[0].data[index].id = cNav.idData;
                        currentNav[0].data[index].title = cNav.title;
                        currentNav[0].data[index].cRouter = cNav.cRouter;
                        currentNav[0].data[index].params = cNav.params;
                        currentNav[0].data[index].currentComponent = cNav.currentComponent;
                        currentNav[0].data[index].activeCurrent = cNav.activeCurrent;
                        currentNav[0].data[index].idGroup = cNav.idGroup;
                    }
                    //console.log(currentNav[0].data[index])
                }
            }
            this._componentRouter.next(this.navComponent);
            sessionStorage.setItem('navComponent', JSON.stringify(this.navComponent));
        }
    };
    ComponentService.prototype.setNavigationChildren = function (cNav, idGroup) {
        var currentNav = this.getCurrentRouterNav(cNav.idTab);
        var index = currentNav[0].data.findIndex(function (res) {
            return res.id == idGroup;
        });
        if (currentNav[0].data[index].id === cNav.idData) {
            currentNav[0].data[index].params = cNav.params;
        }
        var i = currentNav[0].data[index].items.findIndex(function (cItems) { return cItems.id == cNav.idData; });
        if (i < 0) {
            currentNav[0].data[index]['items'].push({
                title: cNav.title,
                cRouter: cNav.cRouter,
                params: cNav.params,
                idGroup: cNav.idGroup,
                idTab: cNav.idTab,
                id: cNav.idData,
                active: true,
            });
        }
        else {
            currentNav[0].data[index].items[i] = {
                id: cNav.idData,
                title: cNav.title,
                cRouter: cNav.cRouter,
                params: cNav.params,
                currentComponent: cNav.currentComponent,
                activeCurrent: cNav.activeCurrent,
                idGroup: cNav.idGroup
            };
        }
        this._componentRouter.next(this.navComponent);
        //console.log('navComponent',this.navComponent)
        sessionStorage.setItem('navComponent', JSON.stringify(this.navComponent));
    };
    ComponentService.prototype.removeChildren = function (id, idGroup, idTab) {
        var currentNav = this.getCurrentRouterNav(idTab);
        var index = currentNav[0].data.findIndex(function (res) {
            return res.id == idGroup;
        });
        var i = currentNav[0].data[index].items.findIndex(function (cItems) { return cItems.id == id; });
        currentNav[0].data[index]['items'] = [];
        this._componentRouter.next(this.navComponent);
        //console.log('navComponent',this.navComponent)
    };
    ComponentService.prototype.getCurrentRouterNav = function (idTab) {
        return this.navComponent.filter(function (res) { return res.idTab == idTab; });
    };
    ComponentService.prototype.show = function () {
    };
    ComponentService.prototype.openComponentCustom = function (componentName, dataToSend, Title, w, h, showToolBarBottom) {
        var _this = this;
        if (w === void 0) { w = 1260; }
        if (h === void 0) { h = 700; }
        if (showToolBarBottom === void 0) { showToolBarBottom = true; }
        if (typeof componentName == 'undefined') {
            return;
        }
        var factories = Array.from(this._componentFactoryResolver['_factories'].keys());
        var factoryClass = factories.find(function (x) { return x.name === componentName; });
        var componentFactory = this._componentFactoryResolver.resolveComponentFactory(factoryClass);
        this.overlaySideService.setTitle(Title);
        this.overlaySideService.setContent(factoryClass);
        this.overlaySideService.sendDataToComponent(dataToSend);
        this.overlaySideService.setToolBarVisible(showToolBarBottom);
        this.overlaySideService.setPopupWidth(w);
        this.overlaySideService.setPopupHeight(h);
        setTimeout(function () {
            if (typeof _this.overlaySideService === 'undefined') {
                //return
            }
            else {
                _this.overlaySideService._hrefComponent.instance.class = 'soggetto-form';
                _this.overlaySideService._hrefComponent.instance.emitData.subscribe(function (x) {
                    _this.dataFromComponent.emit(x); // emette dati al componente chimante
                    //let Risp={key:componente,value:x}       
                });
            }
        }, 500);
        this.overlaySideService.show();
        this.overlaySideService.onPanelClose().subscribe(function (res) {
            _this._closeOverlayForm.next(true);
            //let Risp={key:componente,value:this.overlaySideService._hrefComponent.instance.dataCallBack}
            //if(callBack)
            //callBack(Risp);
        });
    };
    ComponentService.prototype.openComponent = function (componentName, dataToSend, Title, w, h, callBack, componente) {
        var _this = this;
        if (w === void 0) { w = 1260; }
        if (h === void 0) { h = 500; }
        if (callBack === void 0) { callBack = null; }
        if (componente === void 0) { componente = null; }
        if (typeof componentName == 'undefined') {
            return;
        }
        var factories = Array.from(this._componentFactoryResolver['_factories'].keys());
        var factoryClass = factories.find(function (x) { return x.name === componentName; });
        var componentFactory = this._componentFactoryResolver.resolveComponentFactory(factoryClass);
        this.overlaySideService.setTitle(Title);
        this.overlaySideService.setContent(factoryClass);
        this.overlaySideService.sendDataToComponent(dataToSend);
        this.overlaySideService.setToolBarVisible(false);
        this.overlaySideService.setPopupWidth(w);
        this.overlaySideService.setPopupHeight(h);
        setTimeout(function () {
            if (typeof _this.overlaySideService === 'undefined') {
                //return
            }
            else {
                _this.overlaySideService._hrefComponent.instance.class = 'soggetto-form';
                _this.overlaySideService._hrefComponent.instance.emitData.subscribe(function (x) {
                    _this.dataFromComponent.emit(x); // emette dati al componente chimante
                    var Risp = { key: componente, value: x };
                });
            }
        }, 500);
        this.overlaySideService.show();
        this.overlaySideService.onPanelClose().subscribe(function (res) {
            _this._closeOverlayForm.next(true);
            //let Risp={key:componente,value:this.overlaySideService._hrefComponent.instance.dataCallBack}
            //if(callBack)
            //callBack(Risp);
        });
    };
    ComponentService.prototype.getItemsRouterComponentNavigation = function (id, currentTabId) {
        var currentNav = this.getCurrentRouterNav(currentTabId);
        console.log('getItemsRouterComponentNavigation', currentNav);
    };
    ComponentService.prototype.getPrevItemComponentNavigation = function (id, currentTabId) {
        if (this.navComponent.length > 0) {
            var currentNav = this.getCurrentRouterNav(currentTabId);
            var currentItemIndex = currentNav[0].data.findIndex(function (items) { return items.id == id; }) - 1;
            //console.log('getPrevItemComponentNavigation',currentItemIndex)
            if (currentItemIndex > 0) {
                return currentNav[0].data[currentItemIndex];
            }
            //currentNav[0].data.splice(-1);
            //this.navComponent.splice(-1);
            //this._componentRouter.next(currentNav)
        }
    };
    ComponentService.prototype.removeLastItemComponentNavigation = function (currentTabId) {
        if (this.navComponent.length > 0) {
            var currentNav = this.getCurrentRouterNav(currentTabId);
            currentNav[0].data.splice(-1);
            sessionStorage.setItem('navComponent', JSON.stringify(currentNav));
            /* const allElementLength=currentNav[0].data.length  - 1
            //this.navComponent.splice(-1);
            this._componentRouter.next(currentNav) */
        }
    };
    ComponentService.prototype.removeItemComponentNavigation = function (id, currentTabId) {
        if (this.navComponent.length > 0) {
            var currentNav = this.getCurrentRouterNav(currentTabId);
            var currentItemIndex = currentNav[0].data.findIndex(function (items) { return items.id == id; });
            //console.log('removeItemComponentNavigation',currentItemIndex)
            if (currentItemIndex >= 1) {
                currentNav[0].data.splice(currentItemIndex, 1);
            }
            //currentNav[0].data.splice(-1);
            //this.navComponent.splice(-1);
            this._componentRouter.next(currentNav);
            sessionStorage.setItem('navComponent', JSON.stringify(currentNav));
        }
    };
    ComponentService.prototype.removeItemComponentNavigationSede = function (id, currentTabId) {
        if (this.navComponent.length > 0) {
            var currentNav = this.getCurrentRouterNav(currentTabId);
            var currentItemIndex = currentNav[0].data.findIndex(function (items) { return items.id == id; });
            ////console.log('removeItemComponentNavigation',currentItemIndex)
            if (currentItemIndex > 0) {
                currentNav[0].data.splice(currentItemIndex, 1);
            }
            //currentNav[0].data.splice(-1);
            //this.navComponent.splice(-1);
            //this._componentRouter.next(currentNav)
        }
    };
    ComponentService.prototype.removeAllItemComponentFromID = function (id, currentTabId) {
        if (this.navComponent.length > 0) {
            var currentNav = this.getCurrentRouterNav(currentTabId);
            if (currentNav.length > 0) {
                var currentItemIndex = currentNav[0].data.findIndex(function (items) { return items.id == id; });
                if (currentItemIndex >= 0) {
                    var allElementLength = currentNav[0].data.length - 1;
                    currentNav[0].data.splice(currentItemIndex, allElementLength);
                }
            }
        }
    };
    ComponentService.prototype.removeNavigationComponent = function (id, currentTabId) {
        if (this.navComponent.length > 0) {
            var currentNav = this.getCurrentRouterNav(currentTabId);
            var currentItemIndex = this.navComponent.findIndex(function (items) { return items.idTab == currentTabId; });
            this.navComponent.splice(currentItemIndex, 1);
            this._componentRouter.next(this.navComponent);
            sessionStorage.setItem('navComponent', JSON.stringify(this.navComponent));
        }
    };
    ComponentService.prototype.destroyComponentNavigation = function () {
        this.navComponent = [];
        this._componentRouter.next(null);
        this.componentRouter.subscribe(function (re) {
            ////console.log(re)
        });
    };
    ComponentService.prototype.destroyComponentNavigationTab = function (currentTabId) {
        /*this.navComponent = [];
        this._componentRouter.next(null);*/
        if (this.navComponent.length > 0) {
            var currentNav = this.navComponent.findIndex(function (res) { return res.idTab == currentTabId; });
            //this.getCurrentRouterNav(currentTabId);
            this.navComponent.splice(currentNav, 1);
            //console.log('currentNavIndex',this.navComponent);
            sessionStorage.removeItem('navComponent');
            /*const currentItemIndex = currentNav[0].data.findIndex(items=>items.id == id);
            currentNav[0].data.splice(currentItemIndex, currentNav[0].data.length);*/
        }
    };
    ComponentService.prototype.enableHelpNDoc = function (data) {
        this._helpNDoc.next(data);
    };
    ComponentService.prototype.apic = function (value) {
        return "'" + value + "'";
    };
    /**********Gestione PopUp **********/
    ComponentService.prototype.setNewPopUp = function (id, componentName, data, popUpWidth, accessoringData, instancedData, showCaptionFooter, showCaptionHeader, title, position, help, popupHeight) {
        if (popUpWidth === void 0) { popUpWidth = ''; }
        if (showCaptionFooter === void 0) { showCaptionFooter = false; }
        if (showCaptionHeader === void 0) { showCaptionHeader = false; }
        if (title === void 0) { title = ''; }
        if (typeof componentName == 'undefined' || !id) {
            return;
        }
        //console.log('setNewPopUp',this.currentPopupsSet)
        if (!help) {
            help = null;
        }
        if (!position) {
            position = 'center';
        }
        var index = this.currentPopupsSet.findIndex(function (rrrr) { return rrrr.id == id && rrrr.componentName == componentName; });
        if (index < 0) {
            var dataPoUp = {
                componentName: componentName,
                dataToSend: data,
                instancedData: instancedData,
                popUpWidth: popUpWidth,
                showCaptionFooter: showCaptionFooter,
                showCaptionHeader: showCaptionHeader,
                accessoringData: accessoringData,
                action: 'added',
                title: title,
                position: position,
                id: id,
                help: help,
                popupHeight: popupHeight
            };
            this.currentPopupsSet.push(dataPoUp);
            this._popupsSet.next(this.currentPopupsSet);
        }
        else {
            // dataPoUp.action = 'update'
            this.currentPopupsSet[index]['dataToSend'] = data;
            this.currentPopupsSet[index]['action'] = 'update';
            // this.currentPopupsSet[index]['id'] = id;
            this.currentPopupsSet[index]['showCaptionFooter'] = showCaptionFooter;
            this.currentPopupsSet[index]['showCaptionHeader'] = showCaptionHeader;
            this._popupsSet.next(this.currentPopupsSet);
        }
    };
    ComponentService.prototype.setPopUps = function (popUps) {
        this.currentPopupsSet = popUps;
        //this._popupsSet.next(this.currentPopupsSet);
    };
    ComponentService.prototype.destroyCurrentOpenPopUp = function (componentName) {
        var _this = this;
        var arrayEl = this.currentPopupsSet.filter(function (rrrr) { return rrrr.componentName == componentName; });
        if (arrayEl.length > 0) {
            arrayEl.forEach(function (el, index) {
                _this.destroyCurrentOpenPopUpByGuid(el.id);
                /* this.currentPopupsSet.splice(index,1);
                this._popupsSet.next(this.currentPopupsSet);
                try{
          
                  document.getElementsByClassName('modal').item(index).classList.remove('slide-center');
                  document.getElementsByClassName('modal').item(index).classList.add('fade-out-bck');
                 // this._outputComponent.next([]);
            
            
                  ;
                }catch(ex){
                  console.warn(ex);
                } */
            });
        }
    };
    ComponentService.prototype.destroyCurrentOpenPopUpByGuid = function (id) {
        var index = this.currentPopupsSet.findIndex(function (rrrr) { return rrrr.id == id || rrrr.componentName == id; });
        if (index >= 0) {
            this.currentPopupsSet[index].action = 'remove';
            try {
                document.getElementsByClassName('modal').item(index).classList.remove('slide-center');
                document.getElementsByClassName('modal').item(index).classList.add('fade-out-bck');
                this._popupsSet.next(this.currentPopupsSet);
                //this._outputComponent.next([]);
                this.currentPopupsSet.splice(index, 1);
                return true;
            }
            catch (ex) {
                console.warn(ex);
                return false;
            }
        }
        return false;
    };
    ComponentService.prototype.destroyOutputComponent = function () {
        this._outputComponent.next([]);
    };
    ComponentService.prototype.destroyCurrentOpenPopUps = function () {
        this.currentPopupsSet = [];
        this._popupsSet.next([]);
    };
    ComponentService.prototype.setOutputComponent = function (eventFromComponent) {
        this._outputComponent.next(eventFromComponent);
    };
    ComponentService.prototype.setNumberOfNav = function (nTabs) {
        this._numberOfNav.next(nTabs);
        //sessionStorage.setItem('numberOfNav', JSON.stringify(nTabs));
    };
    ComponentService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: OverlaySideFormService },
        { type: ActivatedRoute }
    ]; };
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], ComponentService.prototype, "dataFromComponent", void 0);
    ComponentService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [ComponentFactoryResolver,
            OverlaySideFormService,
            ActivatedRoute])
    ], ComponentService);
    return ComponentService;
}());
export { ComponentService };
//# sourceMappingURL=component.service.js.map